<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          تعریف گروه تخفیفات
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col cols="12"
                 sm="2"
                 v-if="can('newMainJob')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   :to="{name:'mainJobEdit',query:{id:'new'}}"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
<!--            <create-mainJob :model-items="data" :selected="selected" :dialogStatus.sync="showDialog"/>-->
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                dense
                placeholder="جستجو..."
                v-model="searchvalue"
               clearable
                @click:clear="fillDataItems"
            />
            <v-btn  fab small color="primary" @click="search" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="6" class="d-inline-block">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>


        </v-row>


        <v-spacer/>
        <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header  >جستجوی پیشرفته</v-expansion-panel-header>
          <v-expansion-panel-content class="mt-3">
            <v-row>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">
                <v-autocomplete
                    :items="modelAtributes.mainGroupItems"
                    v-model="model.mainGroupId"
                    @input="handleInput"
                    dense
                    outlined
                    @change="getSubGroupList"
                    auto-select-first  append-icon="fas fa-angle-down"
                    label="انتخاب گروه اصلی"

                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">
                <v-autocomplete
                    :items="subGroupItems"
                    v-model="model.subGroupId"
                    @input="handleInput"
                    dense
                    outlined
                    auto-select-first  append-icon="fas fa-angle-down"
                    label="انتخاب گروه فرعی"

                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">

                <v-text-field
                    label="نام "
                    outlined
                    dense
                    v-model="model.name"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">

                <v-text-field
                    label="درصد تخفیف "
                    outlined
                    dense
                    type="number"
                    v-model="model.discountPercent"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">

                <v-text-field
                    label="تلفن"
                    outlined
                    dense
                    v-model="model.phone"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  md="4">

                <v-btn  block   color="primary" @click="advancedSearch" class="mr-1">
                  جستجو
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>

        <v-spacer/>
        <b-table
            class="mt-8"
            v-if="can('mainJobList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
             striped
        >
          <template #cell(actions)="row">

            <v-btn depressed small v-if="can('editMainJob')" color="primary"  :to="{name:'mainJobEdit',query:{id:row.item.id}}"  class="mr-1 ">
              ویرایش
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('deleteMainJob')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import MainJob_se from "./MainJob_se";
import {mapMutations} from "vuex";


export default {
  name: 'MainJob',

  data() {
    return {
      searchvalue: '',
      modelId: '',
      data: {},
      model: {},
      showDialog: false,
      modelAtributes: {},
      subGroupItems: [],
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'mainGroupName', label: 'نام گروه اصلی', sortable: true, sortDirection: 'desc'},
        {key: 'name', label: 'نام', sortable: true, sortDirection: 'desc'},
        {key: 'discountPercent', label: 'درصد تخفیف', sortable: true, sortDirection: 'desc'},
        {key: 'phone', label: 'تلفن', sortable: true, sortDirection: 'desc'},
        {key: 'expirdText', label: 'تاریخ انقضاء', sortable: true, sortDirection: 'desc'},
        {key: 'address', label: 'آدرس', sortable: true, sortDirection: 'desc'},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('MainJob', () => {
      this.fillDataItems()
    })

  },

  methods: {

    close(){
      this.searchvalue=""
      this.$root.$emit('MainJob')
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    handleInput (value) {
      this.$emit('input', value)
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              MainJob_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },

    getSubGroupList(val){
      MainJob_se.getSubGroupList(val).then(response=>{
        return  this.subGroupItems=response.data.subGroupItems
      })
    },

    fillDataItems() {
      this.modelAtributes = (MainJob_se.getPage( this.skip - 1, this.take).then(response => {
        this.modelAtributes = response.data
        this.paging = this.modelAtributes.page
        this.dataItems = this.modelAtributes.mainJobList
        this.model = this.modelAtributes.model

      }));
    },

    search(){
      if(this.searchvalue.length>1){
        MainJob_se.search(this.searchvalue,this.skip-1, this.take).then(result=>{
          this.dataItems=result.data.mainJobs
        })
      }else if(this.searchvalue.length===0){
        this.fillDataItems()

      }
    },
    advancedSearch(){
        MainJob_se.advancedSearch(this.model).then(result=>{
          this.dataItems=result.data.mainJobs
        })
      }


  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
